import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

import { StoreData } from "@/store";
import { Events, useSubscribe } from "@/utils/conductor";
import { computed, ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { Motion } from "motion/vue";
import { spring } from "motion";
import { useI18n } from "vue-i18n";
import { watch } from "vue";
import { isMedium } from "@/utils/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t, locale } = useI18n();

const msg = ref(t("home.title"));
watch([locale], () => {
  msg.value = t("home.title");
});
const activeLetter = ref(-1);

const stringStrength = ref(isMedium() ? 20 : 8);

const updateLetter = () => {
  let newValue = (activeLetter.value + 1) % msg.value.length;
  while (msg.value[newValue] === " ") {
    newValue = (newValue + 1) % msg.value.length;
  }
  activeLetter.value = newValue;
};

useSubscribe(Events.beat, () => updateLetter());

const { state } = useStore<StoreData>();
const waveAnimation = computed(() =>
  state.wave
    ? {
        transform: [
          "translateY(0)",
          "translateY(35%)",
          "translateY(0)",
          "translateY(-35%)",
          0,
        ],
      }
    : { transform: "translateY(0)" }
);
const makeWaveTransition = (index: number) =>
  state.wave
    ? {
        repeat: Infinity,
        delay: index * 0.07,
        duration: 1,
        easing: ["ease-out", "ease-in", "ease-out", "ease-in", "linear"],
      }
    : { duration: 0.3, easing: "ease-out" };

const pivotAnimation = computed(() =>
  state.wave ? { rotate: [0, -5, 0, 5, 0] } : { rotate: 0 }
);
const pivotTrans = computed(() =>
  state.wave
    ? {
        repeat: Infinity,
        duration: 4,
        easing: ["ease-out", "ease-in", "ease-out", "ease-in", "linear"],
      }
    : { duration: 0.5, easing: "ease-out" }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Motion), {
    "aria-label": msg.value,
    class: "max-w-full md:max-w-1/3 min-w-max text-white opacity-70 font-bold text-3xl md:text-5xl lg:text-8xl title-font text-center",
    animate: _unref(pivotAnimation),
    transition: _unref(pivotTrans)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...msg.value], (letter, index) => {
        return (_openBlock(), _createBlock(_unref(Motion), {
          tag: "span",
          class: _normalizeClass(["inline-flex", { 'text-red-500': activeLetter.value === index }]),
          "aria-hidden": "",
          key: index,
          style: _normalizeStyle({
        ...(letter === ' ' ? { width: '0.3em' } : {}),
      }),
          animate: _unref(waveAnimation),
          transition: makeWaveTransition(index)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Motion), {
              tag: "span",
              class: "inline-flex",
              animate: 
          activeLetter.value === index ? { translateY: [-stringStrength.value, 0] } : {}
        ,
              transition: {
          easing: _unref(spring)({
            stiffness: 2500,
            mass: 0.6,
          }),
        }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(letter), 1)
              ]),
              _: 2
            }, 1032, ["animate", "transition"])
          ]),
          _: 2
        }, 1032, ["style", "class", "animate", "transition"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["aria-label", "animate", "transition"]))
}
}

})